(() => {
    'use strict';

    angular
        .module('uwAgenda.users')
        .controller('UserDeactivatingController', [
            '$uibModalInstance',
            'userId',
            UserDeactivatingControllerFn]);

    function UserDeactivatingControllerFn(
        $uibModalInstance,
        userId) {
        let viewModel = this;

        viewModel.userId = userId;
        
        // cancel
        viewModel.no = () => {
            $uibModalInstance.dismiss();
        };

        // ok
        viewModel.yes = () => {
            $uibModalInstance.close();
        };
    }
})();
